module.exports = {"140727100":"昭馀镇","140727101":"东观镇","140727102":"古县镇","140727103":"贾令镇","140727104":"城赵镇","140727105":"来远镇","140727201":"峪口乡","140727400":"祁县经济开发区","140727404":"城区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140727.json
// module id = 417
// module chunks = 0